import React from 'react';

function ListLoadingState({ label = 'Loading…' }) {
  return (
    <div className="ux-list-loading">
      <div className="ux-list-loading-spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export default ListLoadingState;
